module.exports = __webpack_public_path__ + "static/media/1.6b48d0fa.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/slides/LastProjects/assets/1.jpg
// module id = 41
// module chunks = 0